import SvgIcon from '@/pages/home/components/SvgIcon';
import React from 'react';
import { Bubble } from 'tea-component';
import { useIntl } from 'umi';
import { CHARTICONALL } from '@/pages/intelligence/utils/echartsConst';

//全局通用可视化，三类icon切换组件，可任意组合两或者三种
export default function ChartIconType(props: any) {
  const { formatMessage } = useIntl(); // 中英切换方法
  const {
    chartType,
    handleChartType,
    lineIconShow = true,
    barIconShow = true,
    barHorizontalIconShow = false,
    pieIconShow = true,
    iconList = ['bar-horizontal', 'bar', 'line', 'pie'],  //默认可视化三种类型切换
  } = props;

  const filterTypeList = () => {
    return CHARTICONALL.filter(item => { return iconList.findIndex((icon: string) => icon == item.type) > -1 });
  }

  return (
    <>
      <div className="dbi-mobileGames-icon">
        {filterTypeList().map((e: any) => {
          if ((e.type === 'bar-horizontal' && barHorizontalIconShow) || (e.type == 'bar' && barIconShow) || (e.type == 'line' && lineIconShow) || (e.type == 'pie' && pieIconShow)) {
            return (
              <Bubble dark content={formatMessage({ id: e.context })} key={e.type}>
                <div
                  className="icon-item"
                  onClick={() => {
                    handleChartType(e.type);
                  }}
                >
                  <SvgIcon
                    type={e.icon}
                    className={chartType == e.type ? 'item-action' : 'item-icon'}
                  ></SvgIcon>
                </div>
              </Bubble>
            );
          }
        })}
      </div>
    </>
  );
}
